<template>
  <div>
  <component :is="'script'" src="https://apps.elfsight.com/p/platform.js" defer="defer"> </component>
  <div :class="scriptid"></div>
  </div>
</template>

<script>
export default {
  name: "FakeChat",
  props:{
    scriptid: {
      type: String
    }
  }
}
</script>

<style scoped>

</style>